import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const linkStyle = { color: 'var(--primary-color, #4D8FEB)' };

const DeleteAccount: React.FC = () => (
  <>
  <Helmet>
    <title>Delete Your Account — WeaveWords</title>
    <meta name="description" content="How to request deletion of your WeaveWords account and data." />
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href="https://weavewords.org/delete-account" />
  </Helmet>
  <div style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px', color: 'var(--text-dark, #333)', lineHeight: 1.7 }}>
    <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Delete Your Account</h1>
    <p style={{ color: 'var(--text-secondary, #666)', marginBottom: 40 }}>Last updated: September 2026</p>

    <section style={{ marginBottom: 32 }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>How to request deletion</h2>
      <p>
        Account deletion isn't yet self-service in the app. To delete your WeaveWords account and data,
        email <a href="mailto:admin@weavewords.org" style={linkStyle}>admin@weavewords.org</a> from
        the email address on your account and ask us to delete it. We'll delete your data within
        30 days, except where we're required to retain it by law.
      </p>
    </section>

    <section style={{ marginBottom: 32 }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>What gets deleted</h2>
      <ul style={{ paddingLeft: 24 }}>
        <li>Your account (email, display name, avatar, login credentials).</li>
        <li>Your vocabulary items, collections, and tags.</li>
        <li>Your spaced-repetition progress, statistics, streaks, and XP.</li>
        <li>Your settings and preferences.</li>
      </ul>
    </section>

    <section style={{ marginBottom: 32 }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>What we retain, and for how long</h2>
      <p>
        Billing records for any Pro subscription are retained as required for tax/accounting purposes,
        independent of your account. Backups that already contain your data age out on our normal backup
        retention schedule rather than being edited retroactively. Everything else is removed.
      </p>
    </section>

    <section style={{ marginBottom: 40 }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>Questions</h2>
      <p>
        See our <Link to="/privacy" style={linkStyle}>Privacy Policy</Link> for how we handle your data,
        or email <a href="mailto:admin@weavewords.org" style={linkStyle}>admin@weavewords.org</a> with
        any questions.
      </p>
    </section>

    <p style={{ fontSize: 13, color: 'var(--text-secondary, #666)' }}>
      <Link to="/" style={linkStyle}>← Back to Weavewords</Link>
    </p>
  </div>
  </>
);

export default DeleteAccount;
